module.exports = __webpack_public_path__ + "img/blue_170.232b10d4.png";